/**
 * noop.
 * Empty function, mainly used in default callbacks
 *
 * @returns {void}
 */
export function noop(): void {
  return;
}
